import React from 'react'
import { Label } from 'shared/ui'
import ManagedAccordion from 'shared/components/ui/ManagedAccordion'
import { Menu } from 'util/ui'
import Properties from './Properties'

export default class Collection extends React.PureComponent {
  render() {
    const { objects, settings, specificFieldsPattern } = this.props

    return (
      <React.Fragment>
        {objects.map(object => (
          <ManagedAccordion
            key={`object-${object.id}`}
            as={Menu}
            fluid
            initiallyActive={false}
            styled
            collapsed
            title={<Label size="small">{object.label}</Label>}
            vertical
          >
            <Properties
              properties={object.properties}
              settings={settings}
              specificFieldsPattern={specificFieldsPattern}
            />
          </ManagedAccordion>
        ))}
      </React.Fragment>
    )
  }
}
